<script>
// wow.js
const WOW = require('wow.js');
// import 'animate.css';

// vue components
import gotop from './components/Gotop.vue';
import aco from './components/Aco.vue';

// vue components（フォーム関係）
import btnsubmit from './components/BtnSubmit.vue'; //送信ボタン
import formdeleteinvalid from './components/FormDeleteInvalid.vue'; //入力があったらinvalidクラス削除

export default {
    inject: ["mq"],

    components: {
        gotop,
        aco,
        btnsubmit,
        formdeleteinvalid,
    },

    data() {
        return {
            headerH: 0, //ヘッダーの高さ
            gnavActive: false, //グロナビアクティブ管理
            fileSelected: { //フォーム:添付ファイルをいれたかチェック
                input1: false,
                input2: false,
            },
        }
    },

    methods: {
        // wow.js初期化
        wowInit() {
            const wow = new WOW({
                offset: this.mq.mdMinus ? 100 : 300, //SP : PC
                animateClass: 'animate__animated'
            });
            wow.init();
        },

        // ヘッダーの高さを取得
        getHeaderH() {
            const header = this.$refs.header;

            const func = () => {
                this.headerH = header.getBoundingClientRect().height;
            }

            window.addEventListener('load', func);
            window.addEventListener('resize', func);
        },
        
        // フォーム：添付ファイルを入れたかチェック
        handleFileChange(inputKey, e) {
            this.fileSelected[inputKey] = true;
        },
    },

    mounted() {
        this.wowInit();
        // this.getHeaderH();
    },

}
</script>